import { contactContent } from '@/mocks/homeData';
import { useRef, useState, type FormEvent } from 'react';

export default function ContactSection() {
  const formRef = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim().length > 0) {
      setStatus('success');
      return;
    }

    try {
      const resp = await fetch('https://readdy.ai/api/form/d9k3asghpes2mi34sfng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries()).filter(([k]) => k !== 'phone_alt').map(([k, v]) => [k, String(v)])
        ).toString(),
      });
      const responseText = await resp.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (resp.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="py-10 md:py-14 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">{contactContent.title}</h2>
          <p className="text-sm text-foreground-500 mb-8">{contactContent.desc}</p>

          <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="" className="max-w-lg mx-auto space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="您的昵称"
                required
                className="w-full px-4 py-3 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 transition-colors"
              />
              <input
                type="email"
                name="email"
                placeholder="您的邮箱"
                required
                className="w-full px-4 py-3 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
            <input
              type="text"
              name="subject"
              placeholder="主题"
              className="w-full px-4 py-3 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 transition-colors"
            />
            <textarea
              name="message"
              placeholder="请输入您的留言内容..."
              rows={4}
              maxLength={500}
              required
              className="w-full px-4 py-3 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 transition-colors resize-none"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="contact-honeypot"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              发送消息
            </button>

            {status === 'success' && (
              <p className="text-sm text-green-600">消息已发送，感谢您的反馈！</p>
            )}
            {status === 'error' && (
              <p className="text-sm text-red-500">{errorMsg}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}